"use client";

import useIsMobile from "@/hooks/useIsMobile";
import { Dialog } from "@headlessui/react";
import { XIcon } from "lucide-react";
import Image from "next/image";
import Link from "next/link";
import { useEffect, useState } from "react";

const AppPromotionModal = () => {
	const isMobile = useIsMobile();
	const [show, setShow] = useState<boolean>(false);

	const handleClose = () => {
		setShow(false);

		localStorage.setItem("appPromotionModalShown", "true");
	};

	useEffect(() => {
		const isShownPreviously = localStorage.getItem("appPromotionModalShown") === "true";

		if (!isShownPreviously && isMobile) {
			setShow(true);
		}
	}, [isMobile]);

	return (
		<Dialog
			as="div"
			open={show}
			onClose={handleClose}
			className="fixed inset-0 z-30 overflow-y-auto"
		>
			<Dialog.Overlay className="fixed inset-0 bg-black opacity-30" />

			<div className="absolute left-1/2 top-1/2 w-11/12 -translate-x-1/2 -translate-y-1/2 overflow-hidden rounded-lg bg-white shadow-lg lg:max-w-4xl">
				<div className="absolute w-full p-4 text-right">
					<button
						onClick={handleClose}
						className="h-6 w-6 rounded-full bg-brand-primary p-1 text-white outline-none"
					>
						<XIcon className="h-full w-full object-contain" />
					</button>
				</div>

				<div className="bg-[url('/news/popup-bg.png')] bg-no-repeat">
					<div className="flex items-center justify-between gap-4 p-4 md:px-12 md:py-0">
						<div className="md:basis-3/5 md:py-10">
							<Image
								src="/images/home/logo-tile.svg"
								alt="PropTechBuzz Logo"
								className="h-10 w-10 md:h-14 md:w-14"
								width={67}
								height={65}
							/>

							<h3 className="mt-4 text-xl font-bold md:text-3xl">
								PropTechBuzz now has a handy mobile app!
							</h3>

							<p className="mt-3 text-sm font-medium text-gray-600 md:text-lg">
								Explore the latest in proptech on the go. Streamline your search, stay updated with
								new innovations, and connect with the global proptech community—all from the
								convenience of your mobile device.
							</p>

							<div className="mt-3 flex items-center justify-center gap-4 max-md:flex-wrap">
								<Link
									target="_blank"
									href="https://app.proptechbuzz.com"
									className="block w-full rounded-md bg-brand-primary px-6 py-2.5 text-center font-semibold text-white"
								>
									Download App
								</Link>

								<Link
									target="_blank"
									href="https://youtu.be/vgKr-3jOAEw?si=NSEpk6Vr0GoOziS5"
									className="block w-full rounded-md px-6 py-2.5 text-center font-semibold shadow-md hover:bg-gray-100"
								>
									Watch Promo
								</Link>
							</div>

							<div className="mt-6 flex items-center justify-start gap-2">
								<div className="flex items-center -space-x-4">
									<Image
										src="/images/person-2.jpg"
										alt="person image"
										width={100}
										height={100}
										className="h-9 w-9 min-w-[36px] rounded-full border-2 border-white object-cover"
									/>
									<Image
										src="/images/person-3.jpg"
										alt="person image"
										width={100}
										height={100}
										className="h-9 w-9 min-w-[36px] rounded-full border-2 border-white object-cover"
									/>
									<Image
										src="/images/person-1.jpg"
										alt="person image"
										width={100}
										height={100}
										className="h-9 w-9 min-w-[36px] rounded-full border-2 border-white object-cover"
									/>
								</div>
								<p className="text-left text-lg font-semibold text-gray-600">
									<span className="text-brand-primary">1000+</span> downloaded the app
								</p>
							</div>
						</div>

						<div className="relative hidden self-stretch md:block md:basis-2/5">
							<Image
								src="/images/home/app-promotion-modal-image-1.svg"
								alt="PropTechBuzz App Promotion Modal"
								className="absolute left-0 top-10 z-10 h-full w-full"
								width={421}
								height={613}
							/>

							<Image
								src="/images/home/app-promotion-modal-image-2.svg"
								alt="PropTechBuzz App Promotion Modal"
								className="absolute left-2 top-10 h-full w-full rotate-[10deg]"
								width={473}
								height={587}
							/>
						</div>
					</div>
				</div>
			</div>
		</Dialog>
	);
};

export default AppPromotionModal;
